import moment from "moment-timezone";
import {FORMAT, APP, TIMEZONE_OFFSET} from "./constant";

export const getOffset = (timezone) => timezone?.length ? (TIMEZONE_OFFSET[timezone] || moment.tz.zone(timezone).parse() || 0) : 0;
export const getLocalTimezone = () => Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
export const getTimezone = (timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone) => {
    const localTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
    return getOffset(timezone) === getOffset(localTimezone) ? '' : timezone
}
export const dateOrdinal = (date, d1, timezone = APP.DEFAULT_TZ) => {
    const date1 = moment.tz(date, APP.DEFAULT_TZ).clone().format('DD-MM-YYYY')
    const date2 = moment.tz(d1, timezone).clone().format('DD-MM-YYYY')
    if (moment(date1, 'DD-MM-YYYY').isAfter(moment(date2, 'DD-MM-YYYY'), 'day')) {
        return "-1 Day";
    } else if (moment(date1, 'DD-MM-YYYY').isBefore(moment(date2, 'DD-MM-YYYY'), 'day')) {
        return "+1 Day";
    } else {
        return "";
    }
}
/**
 * getIST => localToIST
 * getISTDate => localToIST
 *
 * showIST => istToLocal
 * getLocalDate => istToLocal
 *
 * formatDate => dateFormatter
 * formatTimezone = dateFormatter
 * */
export const dateFormatter = ({
                                  date,
                                  format = FORMAT.DAY_DATE_MONTH,
                                  timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
                              }) => (date ? moment.tz(date, timezone).format(format) : '-')
// To get local timezone string: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone

export const considerTimezone = ({
                               date = new Date(),
                              from = APP.DEFAULT_TZ,
                              to = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
                           } = {}) => {
    const currentDate = new Date(date)
    from = getOffset(from)
    to = getOffset(to)
    let utc = currentDate.getTime() - from * 60 * 1000;
    return new Date(utc + to * 60 * 1000);
};

export const localToIST = (date, flag = 'start') => {
    let from = new Date().getTimezoneOffset();
    let to = new Date().getTimezoneOffset() * 2 + 330;
    let currentDate = new Date();
    const localTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone

    if (flag === 'start') {
        currentDate = new Date(moment(date).tz(localTimezone).clone().startOf('day'))
    } else if (flag === 'end') {
        currentDate = new Date(moment(date).tz(localTimezone).clone().endOf('day'))
    } else {
        currentDate = new Date(moment(date).tz(localTimezone).clone())
    }
    let utc = currentDate.getTime() + from * 60 * 1000;
    return utc - to * 60 * 1000
};

export const istToLocal = (date, flag = 'start') => {
    let to = new Date().getTimezoneOffset();
    let from = new Date().getTimezoneOffset() * 2 + 330;
    let currentDate = new Date();
    const localTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone

    if (flag === 'start') {
        currentDate = new Date(moment(date).tz(APP.DEFAULT_TZ).clone().startOf('day'))
    } else if (flag === 'end') {
        currentDate = new Date(moment(date).tz(APP.DEFAULT_TZ).clone().endOf('day'))
    } else {
        currentDate = new Date(moment(date).tz(APP.DEFAULT_TZ).clone())
    }
    let utc = currentDate.getTime() + from * 60 * 1000;
    return utc - to * 60 * 1000
};
